import { useTranslation } from "react-i18next";
import { TenantResponseFull } from "../../models/tenant";
import { useCliftContext } from "../../hooks/useCliftContext";
import { ReactComponent as PlusIcon } from "../../assets/Plus.svg";
import { ReactComponent as DeleteIcon } from "../../assets/Delete.svg";
import FormField from "../../components/FormField";
import "./TenantFormAdminsPage.css";

interface TenantFormAdminsPageProps {
  originalTenant?: TenantResponseFull | undefined;
  tenant: Omit<TenantResponseFull, "id" | "tenant">;
  admins: string[];
  onAddAdmin: () => void;
  onDeleteAdmin: (index: number) => void;
  onAdminChanged: (index: number, value: string) => void;
}

export const TenantFormAdminsPage = ({
  originalTenant,
  admins,
  onAdminChanged,
  onAddAdmin,
  onDeleteAdmin,
}: TenantFormAdminsPageProps) => {
  const { t } = useTranslation();
  const { cliftState } = useCliftContext();

  return (
    <div className="tenant-form-admins-page">
      <div className="tenant-form-admins-page-creation-row">
        <div>
          <h3>{t("tenant_admins", { ns: "tenant" })}</h3>
          <h4>{t("tenant_admins_hint", { ns: "tenant" })}</h4>
        </div>

        <button
          className="button create-admin-button"
          id="create_admin_button"
          type="button"
          onClick={(e) => {
            e.preventDefault();
            onAddAdmin?.();
          }}
        >
          <PlusIcon />
          {t("new_admin", { ns: "tenant" })}
        </button>
      </div>

      <div className="tenant-form-admins-page-users">
        {admins.map((admin, i) => (
          <div key={i} className="tenant-form-admins-page-user-item">
            <FormField
              title={t("email", { ns: "contact" })}
              name={"email"}
              type="email"
              autoComplete="off"
              value={admin}
              onValueChanged={(_, val) => onAdminChanged(i, val as string)}
              required
            />
            {admins.length > 1 && (
              <button
                className="tenant-form-admins-page-delete-button"
                title={t("delete", { ns: "translation" })}
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  onDeleteAdmin(i);
                }}
              >
                <DeleteIcon />
              </button>
            )}
          </div>
        ))}
      </div>
      <div className="tenant-form-admins-page-email">
        <datalist id="users">
          {originalTenant
            ? cliftState.users
                .filter((user) => user.tenant?.id == originalTenant!.id)
                .map((user) => <option key={user.id}>{user.email}</option>)
            : null}
        </datalist>
      </div>
    </div>
  );
};
